import { FC, useContext, useMemo } from 'external/react'
import { PDFDownloadLink, PDFViewer } from 'external/pdf'
import RdPreviewPDFDocument from './pdf/PdfRd'
import type { NewPlan } from '../plan-rd/index'
import { TeacherContext } from 'teacher/context'
import { initialState } from 'context/index'
import { isUUID, toDownloadableFileName } from 'helpers/utils';
import { IconButton, CloseIcon } from 'external/material';


type PreviewRDProps = {

}

const PreviewRD: FC<PreviewRDProps> = props => {
    const context: any = useContext(TeacherContext) as typeof initialState
    
    const fileName = useMemo(() => isUUID(context.newPlan.id)
       ? toDownloadableFileName(context.newPlan.title || context.newPlan?.content?.titulo || 'planificacion-rd')
       : false, [context.newPlan])
       
    const document = <RdPreviewPDFDocument newPlan={context.newPlan as NewPlan} profile={context.profile} subjects={context.subjects} grades={context.grades} translate={context.translate} />
    return (
      <div style={{width: '100%', height: '100%', padding: 20, display: 'flex', flexDirection: 'column', gap: 12}}>
        <div style={{display: 'flex', justifyContent: 'space-between'}}>
          {fileName && <PDFDownloadLink document={document} fileName={fileName}>
            {({loading, error}) => error ? `Error al generar PDF: ${String(error)}` : loading ? 'Generando PDF...' : 'Descargar PDF'}
          </PDFDownloadLink>}
          <IconButton onClick={() => context.navigate({view: context.newPlanFrom}, '/:languageId/:role/:page/:view', {query: context.newPlanFromQuery})} size='large'><CloseIcon /></IconButton>
        </div>
        {fileName ? <PDFViewer style={{width: '100%', height: '75vh', border: 'none'}}>{document}</PDFViewer> : <span>No hay planificación guardada para previsualizar.</span>}
      </div>
    )

}

export { PreviewRD as default }
